import React from 'react';
import CTAButton from './CTAButton';
export function HeroSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-133">
      <div className="max-w-4xl mx-auto text-center" data-id="element-134">
        <h1 className="text-4xl md:text-6xl font-black mb-3 leading-tight" data-id="element-135">
          <span className="text-yellow-500" data-id="element-136">💰</span>{' '}
          <span className="text-red-600" data-id="element-137">ENSEÑA A TU HIJO</span>{' '}
          <span className="text-black" data-id="element-138">A MANEJAR EL DINERO DESDE PEQUEÑO</span>
        </h1>

        <a href="#compra" className="block my-4" data-id="element-139">
          <img src="https://cdn.magicpatterns.com/uploads/ungnyLYVz6QXVHuQMX84oa/MOCKUP_SIN_FONDI.png" alt="Educación Financiera desde Casa - Pack Completo" className="w-full max-w-2xl mx-auto hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-140" />
        </a>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-141">
          (antes de que aprenda a perderlo)
        </h2>

        <CTAButton text="¡SÍ! QUIERO ACCEDER AHORA" data-id="element-142" />
      </div>
    </section>;
}
export default HeroSection;